import { render, staticRenderFns } from "./PeopleAndRoles.vue?vue&type=template&id=cf1513b4&scoped=true&"
import script from "./PeopleAndRoles.vue?vue&type=script&lang=js&"
export * from "./PeopleAndRoles.vue?vue&type=script&lang=js&"
import style0 from "./PeopleAndRoles.vue?vue&type=style&index=0&id=cf1513b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1513b4",
  null
  
)

export default component.exports